import { gql } from '@apollo/client'
import { PRODUCT_FRAGMENT } from '@/graphql/fragments/product'
import { LEADER_ADDRESS_DETAIL_FRAGMENT } from '@/graphql/fragments/addressDetail'
import { LEGAL_STATUS_FRAGMENT } from '@/graphql/fragments/legalStatus'

export const SOCIETY_FRAGMENT = gql`
  fragment SocietyFragment on Society {
    id
    formality {
      ...ProductFragment
    }
    name
    rcs
    projectType
    addressDetail {
      ...LeaderAddressDetailFragment
    }
    legalStatus {
      ...LegalStatusFragment
    }
  }
  ${PRODUCT_FRAGMENT}
  ${LEADER_ADDRESS_DETAIL_FRAGMENT}
  ${LEGAL_STATUS_FRAGMENT}
`
